import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaTimes } from 'react-icons/fa';
import './footer.css';

const SERVICES = [
  { label: 'Tally Prime',          to: '/tallyprime' },
  { label: 'Mobile App Dev',       to: '/MobileDeveloper' },
  { label: 'Web Development',      to: '/WebDevelopment' },
  { label: 'Hardware Solutions',   to: '/HardwareServices' },
  { label: 'CCTV & Security',      to: '/SecuritySystem' },
  { label: 'Server Management',    to: '/ServerPage' },
  { label: 'Biometrics',           to: '/BIO' },
  { label: 'Antivirus',            to: '/Antivirus' },
];

const COMPANY = [
  { label: 'About Us',    to: '/AboutPage' },
  { label: 'Milestones', to: '/timelines' },
  { label: 'Customers',  to: '/Client' },
  { label: 'Careers',    to: '/career_pages' },
  { label: 'Contact Us', to: '/contact' },
  { label: 'Social & QR Hub', to: '/connect' },
];

const SOCIALS = [
  {
    href: 'https://www.facebook.com/imatrix.pvt',
    icon: 'fab fa-facebook',
    label: 'Facebook',
  },
  {
    href: 'https://www.instagram.com/imatrix.t/',
    icon: 'fab fa-instagram',
    label: 'Instagram',
  },
  {
    href: 'https://in.linkedin.com/company/imatrix-t',
    icon: 'fab fa-linkedin',
    label: 'LinkedIn',
  },
  {
    href: 'https://www.youtube.com/@imatrixtechnologies1833/featured',
    icon: 'fab fa-youtube',
    label: 'YouTube',
  },
];

const Footer = ({ onLogoClick }) => {
  const [activePolicyModal, setActivePolicyModal] = useState(null);

  return (
    <footer className="footer" aria-label="Site footer">
      <div className="footer-main">
        {/* Brand / Contact */}
        <div className="footer-brand">
          <div>
            <div className="footer-brand__logo">
              <img
                src="/images/Customer_logo/imatrix_white_logo.png"
                alt="iMatrix Technologies"
                loading="lazy"
                onClick={onLogoClick}
                title="·"
                style={{ cursor: onLogoClick ? 'pointer' : 'default' }}
              />
            </div>

            <p className="footer-brand__desc">
              iMatrix Technologies Pvt Ltd — delivering innovative technology solutions
              since 2006. We pride ourselves on excellence, reliability, and customer‑first service.
            </p>
          </div>
          <div className="footer-brand__contact">
            <div className="footer-contact-item">
              <span className="footer-contact-item__icon" aria-hidden="true"><FaPhone /></span>
              <a href="tel:+919841609990">+91 98416 09990</a>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-item__icon" aria-hidden="true"><FaEnvelope /></span>
              <a href="mailto:admin@imatrixtechnologies.com">admin@imatrixtechnologies.com</a>
            </div>
            <a href="https://www.google.com/maps?ll=13.068722,80.216376&z=16&t=m&hl=en&gl=IN&mapclient=embed&cid=10554500636439021061">
            <div className="footer-contact-item address-item">
              <span className="footer-contact-item__icon" aria-hidden="true"><FaMapMarkerAlt /></span>
              <span>R 76, Water Tank Rd, R Block, MMDA Colony, Arumbakkam, Chennai, Tamil Nadu 600106</span>
            </div> </a>
          </div>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3>Services</h3>
          <ul>
            {SERVICES.map((s) => (
              <li key={s.to}>
                <Link className="footer-link" to={s.to}>{s.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div className="footer-section">
          <h3>Company</h3>
          <ul>
            {COMPANY.map((c) => (
              <li key={c.to}>
                <Link className="footer-link" to={c.to}>{c.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Social */}
        <div className="footer-section footer-social">
          <h3 className="footer-social__label">Follow Us On</h3>
          <div className="social-icons" aria-label="Social media links">
            {SOCIALS.map((s) => (
              <a
                key={s.href}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
              >
                <i className={s.icon} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copyright">
            © {new Date().getFullYear()} iMatrix Technologies Pvt Ltd. All rights reserved.
            {/* Easter Egg: hover the hidden dot for a dev credit */}
            <span className="footer-dev-credit">
              ·
              <span className="footer-dev-credit__tooltip">Built with ❤️ by the iMatrix Web Team · Chennai, TN</span>
            </span>
          </p>

          <div className="footer-policy-links">
            <span className="footer-policy-link" style={{ cursor: 'pointer' }} onClick={() => setActivePolicyModal('terms')}>Terms of Use</span>
            <span className="footer-policy-link" style={{ cursor: 'pointer' }} onClick={() => setActivePolicyModal('privacy')}>Privacy Policy</span>
          </div>
          <div className="footer-bottom-badge" aria-label="Made in India">
            🇮🇳 Made in India
          </div>
        </div>
      </div>

      {/* ── Policy Modal Dialog Overlay ── */}
      {activePolicyModal && (
        <div className="policy-modal-overlay" onClick={() => setActivePolicyModal(null)} style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(15, 23, 42, 0.5)',
          backdropFilter: 'blur(8px)',
          zIndex: 11000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div className="policy-modal-card" onClick={(e) => e.stopPropagation()} style={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '24px',
            width: '100%',
            maxWidth: '650px',
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            color: '#1e293b',
            animation: 'modalEnter 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards'
          }}>
            <header style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px 24px',
              borderBottom: '1px solid #e2e8f0'
            }}>
              <h2 style={{ fontSize: '1.3rem', fontWeight: '800', margin: 0, color: 'var(--brand-deep, #2d2d2a)' }}>
                {activePolicyModal === 'terms' ? 'Terms of Use' : 'Privacy Policy'}
              </h2>
              <button onClick={() => setActivePolicyModal(null)} style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#64748b',
                fontSize: '1.2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '4px'
              }}>
                <FaTimes />
              </button>
            </header>
            
            <div style={{
              padding: '24px',
              overflowY: 'auto',
              fontSize: '0.95rem',
              lineHeight: '1.6',
              color: '#334155'
            }}>
              {activePolicyModal === 'terms' ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <p>Welcome to <strong>iMatrix Technologies</strong>. By accessing or using our website and services, you agree to comply with and be bound by the following terms and conditions.</p>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>1. Services Offered</h4>
                    <p>iMatrix Technologies provides enterprise IT infrastructure solutions, Tally Prime accounting software partnerships, biometric authentication integrations, custom mobile and web applications (FAR, e-Warehouse, Logistics portals), and IT consultancy.</p>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>2. Use of Site Content</h4>
                    <p>All trademarks, graphics, UI components, code, text, and mockups on this website are the intellectual property of iMatrix Technologies Pvt Ltd. Unauthorized copying, distribution, or modifications are strictly prohibited.</p>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>3. User Submissions</h4>
                    <p>Any details submitted via our Careers Portal or Contact Us forms must represent true, accurate, and up-to-date information. Fraudulent entries or file uploads carrying malicious software will result in immediate termination of access and potential legal action.</p>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>4. Liabilities</h4>
                    <p>While we make every effort to maintain the accuracy of our digital portals, iMatrix Technologies Pvt Ltd is not liable for temporary service interruptions, network failures, or errors in external API data.</p>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>5. Governing Jurisdiction</h4>
                    <p>These terms are governed and construed in accordance with the laws of India. Any disputes arising in connection with our services will be subject exclusively to the courts of Chennai, Tamil Nadu.</p>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <p>At <strong>iMatrix Technologies</strong>, safeguarding your personal data and transparency in tracking is a key priority. This Privacy Policy details how we collect, process, and store your details.</p>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>1. Information Collection</h4>
                    <p>We collect information directly provided by you (such as your name, mobile, email, and resume files during Contact or Careers submission) and basic automated site metrics (landing path, screen size, user-agent details, and region via safe geolocation APIs).</p>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>2. How We Use Your Data</h4>
                    <p>Collected data is used strictly to evaluate job candidacies, process support/inquiry tickets, schedule sales consultations, and compile aggregated visitor logs to optimize site performance.</p>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>3. Storage & Security</h4>
                    <p>Your details are transferred securely to verified storage systems, including Google Sheets databases using secured App Script protocols. We implement proper encryption keys to ensure unauthorized personnel cannot intercept your files.</p>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>4. Third-Party Sharing</h4>
                    <p>iMatrix Technologies does not sell, lease, or share your contact info or professional details with third-party advertisers. Data is accessed solely by authorized recruiters and sales personnel.</p>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 6px 0', fontWeight: '700', color: 'var(--brand, #6b7a52)' }}>5. Contact & Updates</h4>
                    <p>If you wish to view, update, or request the deletion of your submitted data, you can email us directly at <strong>admin@imatrixtechnologies.com</strong>.</p>
                  </div>
                </div>
              )}
            </div>
            
            <footer style={{
              display: 'flex',
              justifyContent: 'flex-end',
              padding: '16px 24px',
              borderTop: '1px solid #e2e8f0',
              background: '#f8fafc'
            }}>
              <button onClick={() => setActivePolicyModal(null)} style={{
                padding: '8px 18px',
                background: 'var(--brand-deep, #2d2d2a)',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                fontWeight: '700',
                cursor: 'pointer'
              }}>
                Close
              </button>
            </footer>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
